<div class="page">
    <app-page-header titulo="Censo FFSJ" icono="bi-house-door-fill"
        descripcion="Gestión del censo de la Federació de Les Fogueres de Sant Joan. Elige una sección."></app-page-header>

    @if (!permisos.cargado()) {
        <div class="home-grid" role="status" aria-label="Cargando tus permisos">
            @for (n of [1, 2, 3]; track n) { <div class="skeleton skeleton--card home-skeleton"></div> }
            <span class="visually-hidden">Cargando tus permisos…</span>
        </div>
    } @else if (visibles().length === 0) {
        <app-estado-panel icono="bi-lock" titulo="Sin acceso a las secciones de administración"
            texto="Tu cuenta no tiene permisos de Censo asignados por su cargo. Si crees que deberías tenerlos, contacta con la Federación para que los configure."></app-estado-panel>
    } @else {
        @if (visiblesCenso().length) {
            <section aria-labelledby="home-censo">
                <h2 id="home-censo" class="home-section">Censo</h2>
                <div class="home-grid">
                    @for (item of visiblesCenso(); track item.id) {
                        <a class="home-tile" [routerLink]="item.url" [attr.data-seccion]="item.seccion">
                            <span class="home-tile__icon" aria-hidden="true"><i class="bi" [class]="item.icono"></i></span>
                            <span class="home-tile__body">
                                <span class="home-tile__title">{{ item.titulo }}</span>
                                <span class="home-tile__text">{{ item.descripcion }}</span>
                            </span>
                            <i class="bi bi-chevron-right home-tile__chev" aria-hidden="true"></i>
                        </a>
                    }
                </div>
            </section>
        }
        @if (visiblesAdmin().length) {
            <section aria-labelledby="home-admin">
                <h2 id="home-admin" class="home-section">Administración</h2>
                <div class="home-grid">
                    @for (item of visiblesAdmin(); track item.id) {
                        <a class="home-tile" [routerLink]="item.url" [attr.data-seccion]="item.seccion">
                            <span class="home-tile__icon" aria-hidden="true"><i class="bi" [class]="item.icono"></i></span>
                            <span class="home-tile__body">
                                <span class="home-tile__title">{{ item.titulo }}</span>
                                <span class="home-tile__text">{{ item.descripcion }}</span>
                            </span>
                            <i class="bi bi-chevron-right home-tile__chev" aria-hidden="true"></i>
                        </a>
                    }
                </div>
            </section>
        }
    }
</div>
